import { writeJson } from '@ms-cloudpack/json-utilities';
import type { BundleRequest } from '../types/BundleRequest.js';
import type { ResultJson } from '../types/ResultJson.js';
import { getResultJsonPath } from './getResultJsonPath.js';

/**
 * Writes the bundleRequestResults to a 'results.json' file.
 * @param bundleRequestResult - The result object to write to the cache.
 */
export async function saveResultToCache(bundleRequestResult: NonNullable<BundleRequest['result']>): Promise<void> {
  const { outputPath, bundler, bundlerVersion, entries, hash, outputFiles, warnings, errors } = bundleRequestResult;
  if (!outputPath) {
    return;
  }

  const result: ResultJson = {
    bundler,
    bundlerVersion,
    entries,
    hash,
    outputFiles,
    warnings,
    errors,
  };

  await writeJson(getResultJsonPath(outputPath), result);
}
